const GTM_ID = 'GTM-WTRCJ633';
const HUBSPOT_PORTAL_ID = '143647097';

declare global {
  interface Window {
    dataLayer?: any[];
    __hhThirdPartyBooted?: boolean;
  }
}

const appendScript = (id: string, src: string, extra?: Partial<HTMLScriptElement>) => {
  if (document.getElementById(id)) return;
  const s = document.createElement('script');
  s.id = id;
  s.src = src;
  s.async = true;
  if (extra) Object.assign(s, extra);
  document.head.appendChild(s);
};

export const bootThirdPartyScripts = () => {
  if (window.__hhThirdPartyBooted) return;
  window.__hhThirdPartyBooted = true;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  appendScript('hh-gtm-loader', `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`);

  appendScript('hs-script-loader', `https://js-eu1.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`);
};
